module.exports = __webpack_public_path__ + "img/noimg.9176e451.jpeg";